import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

import { Button } from "@/components/ui/Button";

type TEmptyStateProps = {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  className?: string;
};

export function EmptyState({ icon, title, description, action, className }: TEmptyStateProps) {
  return (
    <div className={cn("rounded-lg border border-dashed border-border bg-muted p-6 text-center", className)}>
      {icon && <div className="mb-2 flex justify-center">{icon}</div>}
      <p className="text-sm font-medium text-muted-foreground">{title}</p>
      {description && <p className="mt-1 text-xs text-muted-foreground">{description}</p>}
      {action && (
        <Button
          variant="outline"
          size="sm"
          className="mt-3"
          onClick={action.onClick}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
}
